import ShopService from '@/services/ShopService'

export default {
  state: {
    shop: {},
    shops: [],
    total: null,
    totalRequest: null
  },
  mutations: {
    ADD_SHOP(state, shop) {
      state.shops.push(shop)
    },
    SET_SHOPS(state, shops) {
      state.shops = shops
    },
    SET_SHOPS_TOTAL(state, total) {
      state.total = total
    },
    SET_SHOPS_TOTAL_REQUEST(state, totalRequest) {
      state.totalRequest = totalRequest
    },
    SET_SHOP(state, shop) {
      state.shop = shop
    }
  },
  actions: {
    /**
     * Fetch in state list of shops
     *
     * @param commit
     * @param centerId
     * @param perPage
     * @param page
     * @param order
     * @param search
     */
    fetchShops({ commit }, { centerId, perPage, page, order, search }) {
      return ShopService.getShops(
        centerId,
        (perPage) ? perPage: null,
        (page) ? page: null,
        (order) ? order : null,
        (search) ? search : null)
        .then(response => {
          commit('SET_SHOPS', response.data.list)
          commit('SET_SHOPS_TOTAL', response.data.total)
          commit('SET_SHOPS_TOTAL_REQUEST', response.data.totalRequest)

          return Promise.resolve(response.data.list)
        })
        .catch(error => {
        })
    },
    /**
     * Fetch in state list of shops
     *
     * @param commit
     * @param centerId
     */
    fetchShopsByCenter({ commit }, { centerId }) {
      return ShopService.getShopsByCenter(centerId)
        .then(response => {
          commit('SET_SHOPS_CENTERS', response.data)

          return Promise.resolve(response.data)
        })
        .catch(error => {
        })
    },
    /**
     * Fetch in state a shop
     *
     * @param commit
     * @param getters
     * @param shopId
     */
    fetchShop({ commit }, shopId)
    {
      ShopService.getShop(shopId)
        .then(response => {
          commit('SET_SHOP', response.data)
        })
        .catch((error) => {
        })
    },
    /**
     * Create shop
     *
     * @param commit
     * @param shop
     */
    createShop({ commit }, shop)
    {
      return ShopService.create(shop)
        .then((response) => {
          // Check if has errors on form
          if(response.data.errors) {
            return Promise.reject(response.data.errors)
          }

          commit('ADD_SHOP', shop)
          return Promise.resolve()
        })
    },
    /**
     * Update shop
     *
     * @param commit
     * @param model
     * @returns {*}
     */
    updateShop({ commit }, model)
    {
      return ShopService.edit(model)
        .then((response) => {
          if(response.data.errors) {
            return Promise.reject(response.data.errors)
          }

          commit('SET_SHOP', response.data)
        })
    }
  },
  getters: {
    /**
     * Get shop by id in list shops
     *
     * @param state
     * @returns {function(*): *}
     */
    getShopById: state => id => {
      return state.shops.find(shop => shop.id === id)
    },
    getShops: state => {
      return state.shops
    }
  }
}
